export interface AuthRequest {
  email: string;
  password: string;
  device_name: string; // são dados do app via app-view
  device_token: string; // são dados do app via app-view
}
export interface AuthResponse {
  token: string;
  refresh_token: string;
  legacy_token: string;
  session_id: string;
}
export interface AuthErrorResponse {
  error?: string;
  message: string;
}
export interface AuthGetMeResponse {
  uuid: string;
  status: string;
  status_of_service: string;
  email: string;
  attributes: Attributes;
  roles: Role[];
  permissions: Permission[];
  active_account: ActiveAccount;
  accounts: Account[];
  account_channels: AccountChannel[];
  teams: Team[];
  addresses: any[];
  metadata: AccountMetadata;
}
export interface Role {
  uuid: string;
  name: string;
  label: string;
}

export interface Permission {
  uuid: string;
  name: string;
  label: string;
}
export interface Account {
  uuid: string;
  attributes: Attributes;
  metadata: ActiveAccountMetadata;
}

export interface ActiveAccount {
  uuid: string;
  attributes: Attributes;
  metadata: ActiveAccountMetadata;
}
export interface Attributes {
  name: string;
  doc: string;
  segment: string;
}

export interface AccountChannel {}
export interface Team {}

export interface AccountMetadata {
  deprecated_user_id: number;
  created_at: string;
  updated_at: string;
}

export interface ActiveAccountMetadata {
  deprecated_customer_id: number;
  created_at: string;
  updated_at: string;
  can_use_system: boolean;
}

export const roleLegacyMapping: Record<string, number> = {
  adm: 1,
  agent: 2,
  manager: 3,
  lead: 4,
  supervisor: 5,
};
